// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IAFVS","label":"styles_label__THkoU"};